import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import axios from "axios";
import "./App.scss";
import Header from "./Component/Header/Header";
import SideBar from "./Component/SideBar/SideBar";
import SideBarMobile from "./Component/SideBar/SideBarMobile";
import { jwtDecode } from "jwt-decode";
import LoginPage from "./Component/LoginPage/LoginPage";
import Nine911 from "./Component/911";
import NeedAssistance from "./Component/LoginPage/NeedAssistance";
import HealthStatus from "./Component/HealthStatus/HealthStatus/HealthStatus";
import FloorManagement from "./Component/FloorManagement/FloorManagement";
import DevicesComp from "./Component/DevicesComp/DevicesComp";
import Profile from "./Component/Profile/Profile";
import Customer from "./Component/Customer/Customer";
import BuildingManagement from "./Component/BuildingManagement/BuildingManagement";
import AddDevices from "./Component/FloorManagement/AddDevices";
import CentralMonitoringScreen from "./Component/CentralMonitoringScreen/CentralMonitoringScreen";
import GlobalSetting from "./Component/GlobalSetting/GlobalSetting";
import ProtectedRoute from "./ProtectedRoute";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import MangeUser from "./Component/MangeUser/MangeUser";
import { useLoadScript } from "@react-google-maps/api";
import isAccess from "./utils/checkAccess";
import { useMediaQuery } from "@mui/material";
import ZoomClassSync from './ZoomClassSync'

import { connectMQTT } from "./Actions/mqttActions";
import "./assets/styles/tabList.scss";
import "./assets/styles/glButton.scss";

function App() {
  const [userDataStorage, setUserDataStorage] = useState("");
  const accountId = parseInt(window.location.pathname.split("/")[1]);
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });
  const [isInactive, setIsInactive] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(180); // Timeout countdown in seconds
  const token = JSON.parse(localStorage.getItem("token"));
  let decodedToken = "";
  if (token) {
    decodedToken = jwtDecode(token);
  }
  const { view: viewFloorMaps } =
    decodedToken !== ""
      ? isAccess(decodedToken.userRole, "Floor Management")
      : { view: false };
  const { view: viewUserManagement } =
    decodedToken !== ""
      ? isAccess(decodedToken.userRole, "User Management")
      : { view: false };
  const { view: viewCustomerManagement } =
    decodedToken !== ""
      ? isAccess(decodedToken.userRole, "Customer Management")
      : { view: false };
  const { view: viewGlobalApplication } =
    decodedToken !== ""
      ? isAccess(decodedToken.userRole, "Global Application")
      : { view: false };

  const [modalActive, setModalActive] = useState(false);
  const [redirected, setRedirected] = useState(false);
  const [isAuthentication, setIsAuthentication] = useState(false);
  const loginDetail = useSelector((state) => state.login);
  const ispad = useMediaQuery("(max-width:960px)");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    dispatch({
      type: "ISLOADED_LOADERROR",
      payload: {
        loadError,
        isLoaded,
      },
    });
  }, [isLoaded, loadError]);

  let inactivityTimeout;
  let countdownInterval;

  // useEffect(() => {
  //   const storedDrillMode = localStorage.getItem("drill_mode");

  //   if (storedDrillMode === "1" || storedDrillMode === "true") {
  //     dispatch(toggleSnackbar(true));
  //   }
  // }, [dispatch]);

  // useEffect(() => {
  //   localStorage.setItem("drill_mode", enableSnackbar);
  // }, [enableSnackbar]);

  // useEffect(() => {
  //   const fetchSettings = async () => {
  //     let token = JSON.parse(localStorage.getItem("token"));
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_URL}/auth/getAllListGlobalAppSetting`,{
  //               headers: {
  //                   'Content-Type': 'application/json',
  //                   'Authorization': `Bearer ${token}`
  //               },
  //           }
  //       );
  //       const fetchedSettings = {};

  //       response.data.allGlobalSettings.forEach((item) => {
  //         fetchedSettings[item.code] = item.value;
  //       });

  //       if (fetchedSettings["drill_mode"] === "1") {
  //         dispatch(toggleSnackbar(true));
  //       } else if (fetchedSettings["drill_mode"] === "0") {
  //         dispatch(toggleSnackbar(false));
  //       }
  //     } catch (error) {
  //       console.error("Error fetching settings:", error);
  //     }
  //   };

  //   fetchSettings();
  // }, []);

  const startInactivityTimer = () => {
    const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
    if (isAuthenticated) {
      const currentTime = Date.now();
      localStorage.setItem("lastActivityTime", currentTime);

      clearTimeout(inactivityTimeout);
      inactivityTimeout = setTimeout(() => {
        const lastActivityTime = parseInt(
          localStorage.getItem("lastActivityTime"),
          10
        );
        const elapsedTime = Date.now() - lastActivityTime;

        if (elapsedTime >= 12 * 60 * 1000 && elapsedTime < 15 * 60 * 1000) {
          setIsInactive(true);
          setModalActive(true);
          startCountdown();
        } else if (elapsedTime >= 15 * 60 * 1000) {
          // handleLogout();
        }
      }, 12 * 60 * 1000);
    }
  };

  const startCountdown = () => {
    clearInterval(countdownInterval);
    setTimeRemaining(180); // 3 minutes
    countdownInterval = setInterval(() => {
      setTimeRemaining((prevTime) => {
        if (prevTime <= 0) {
          clearInterval(countdownInterval);
          // handleLogout();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  };

  const resetSession = () => {
    setIsInactive(false);
    setModalActive(false);
    clearInterval(countdownInterval);
    startInactivityTimer();
  };

  const handleLogout = () => {
    const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
    if (isAuthenticated) {
      clearTimeout(inactivityTimeout);
      clearInterval(countdownInterval);
      setUserDataStorage("");
      localStorage.removeItem("token");
      dispatch({ type: "LOGOUT" });
      navigate("/", { replace: true });
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("isMFACompleted");
      localStorage.removeItem("lastPath");
      setIsAuthentication(false);
      setIsInactive(false);
      setModalActive(false);
    }
  };
  useEffect(() => {
    console.log("mqtttcall");
    dispatch(connectMQTT());
  }, [dispatch]);
  useEffect(() => {
    const initializeApp = () => {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const lastPath = localStorage.getItem("lastPath");
      const lastActivityTime = parseInt(
        localStorage.getItem("lastActivityTime"),
        10
      );
      const elapsedTime = Date.now() - lastActivityTime;

      if (storedToken) {
        setUserDataStorage(storedToken);
        if (!redirected && !accountId) {
          setRedirected(true);
          navigate(lastPath || "/", { replace: true });
        }

        if (elapsedTime >= 15 * 60 * 1000) {
          // Logout if inactivity exceeds 15 minutes
          // handleLogout();
        } else if (elapsedTime >= 12 * 60 * 1000) {
          // Show the dialog if within the countdown window
          setIsInactive(true);
          setModalActive(true);
          startCountdown();
        } else {
          startInactivityTimer();
        }
      } else {
        handleLogout();
      }
    };

    initializeApp();

    const resetInactivityTimer = () => {
      if (!modalActive) {
        const currentTime = Date.now();
        localStorage.setItem("lastActivityTime", currentTime);
        clearTimeout(inactivityTimeout);
        startInactivityTimer();
      }
    };

    window.addEventListener("mousemove", resetInactivityTimer);
    window.addEventListener("keydown", resetInactivityTimer);
    window.addEventListener("click", resetInactivityTimer);

    return () => {
      clearTimeout(inactivityTimeout);
      clearInterval(countdownInterval);
      window.removeEventListener("mousemove", resetInactivityTimer);
      window.removeEventListener("keydown", resetInactivityTimer);
      window.removeEventListener("click", resetInactivityTimer);
    };
  }, [redirected, modalActive]);

  useEffect(() => {
    if (userDataStorage && !accountId) {
      localStorage.setItem("lastPath", location.pathname);
    }
  }, [location.pathname, userDataStorage]);

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
    const isMFACompleted = localStorage.getItem("isMFACompleted") === "true";
    setIsAuthentication(isAuthenticated && isMFACompleted);
  }, [loginDetail]);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
        alert("Your session has expired or your account has been deleted.");
          handleLogout();
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  const isDevicesPage = location.pathname.includes("/devices");

  console.log(!isDevicesPage, loginDetail.showSidebar)

  return (
    <>
      <ZoomClassSync />
      <DndProvider backend={HTML5Backend}>
        <div className="App">
          {!isAuthentication ? (
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route path="/mfa-options" element={<LoginPage />} />
              <Route path="/ForgotPassword" element={<LoginPage />} />
              <Route path="/resetPassword" element={<LoginPage />} />
              <Route
                path="/needAssistanceandsupport"
                element={<NeedAssistance />}
              />
              <Route path="/:accountId" element={<Nine911 />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          ) : (
            <>
              <Header />
              <div className="middle_container">
                {!isDevicesPage && loginDetail.showSidebar && (ispad ? <SideBarMobile /> : <SideBar />)}
                <Routes>
                  <Route
                    path="/healthStatus/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthentication}>
                        <HealthStatus />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/floorManagement"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthentication}>
                        <FloorManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/buildingManagement"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthentication}>
                        <BuildingManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/Dashboard"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthentication}>
                        <CentralMonitoringScreen />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/device"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthentication}>
                        <DevicesComp />
                      </ProtectedRoute>
                    }
                  />
                  {viewCustomerManagement && (
                    <Route
                      path="/customer"
                      element={
                        <ProtectedRoute isAuthenticated={isAuthentication}>
                          <Customer />
                        </ProtectedRoute>
                      }
                    />
                  )}
                  <Route
                    path="/profile"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthentication}>
                        <Profile />
                      </ProtectedRoute>
                    }
                  />
                  {viewGlobalApplication && (
                    <Route
                      path="/globalSettings"
                      element={
                        <ProtectedRoute isAuthenticated={isAuthentication}>
                          <GlobalSetting />
                        </ProtectedRoute>
                      }
                    />
                  )}
                  {viewUserManagement && (
                    <Route
                      path="/manageUser"
                      element={
                        <ProtectedRoute isAuthenticated={isAuthentication}>
                          <MangeUser />
                        </ProtectedRoute>
                      }
                    />
                  )}
                  {viewFloorMaps && (
                    <Route
                      path="/floorManagement/assignDevices/:id"
                      element={
                        <ProtectedRoute isAuthenticated={isAuthentication}>
                          <AddDevices />
                        </ProtectedRoute>
                      }
                    />
                  )}
                  <Route path="/:accountId" element={<Nine911 />} />
                  <Route
                    path="*"
                    element={<Navigate to="/Dashboard" replace />}
                  />
                </Routes>
              </div>
            </>
          )}
        </div>
      </DndProvider>
    </>
  );
}

export default App;
